import type { FC } from 'react';
import LoadingOverlay from '@components/LoadingOverlay';
import { BlockLibraryCreatorListController } from '@features/block-library-creator-list';

import { useBlockCreator } from '../../context/context';
import { useLibraryInsert } from '../../hooks/useLibraryInsert';
import type { LibraryStepId } from '../../types';
import { StepView } from '../StepView';

interface StepLibraryProps {
  stepId: LibraryStepId;
}

export const StepLibrary: FC<StepLibraryProps> = ({ stepId }) => {
  const { onPrevStep } = useBlockCreator();
  const { isInserting, onInsertBlock, onInsertSelectedBlocks } = useLibraryInsert();
  const isBlockLibrary = stepId === 'library-block';

  return (
    <StepView
      stepId={stepId}
      secondHeaderTitle={isBlockLibrary ? 'Search Block Library' : 'Search Clause Library'}
      onPrev={onPrevStep}
    >
      <LoadingOverlay active={isInserting} />
      <BlockLibraryCreatorListController
        onInsertBlock={onInsertBlock}
        onInsertSelectedBlocks={onInsertSelectedBlocks}
        type={isBlockLibrary ? 'block' : 'clause'}
      />
    </StepView>
  );
};
